module.exports = __webpack_public_path__ + "static/media/menu.31b365cf.svg";